define( [
	"./core",
	"./attributes/attr",
	"./attributes/prop",
	"./attributes/classes",
	"./attributes/val"
], function( jQuery ) {

"use strict";

// Return jQuery for attributes-only inclusion
return jQuery;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/attributes.js
// module id = 1290
// module chunks = 0